import { ChatUserData } from "@virtualprogaming/js-public-sdk";
import { useQuery, UseQueryOptions } from "react-query";

import { useChatApi } from "./useChatApi";

export function useSearchChatUsers(
  search: string,
  top: number,
  options?: UseQueryOptions<ChatUserData>
) {
  const api = useChatApi();
  return useQuery({
    queryKey: ["chat-users-search", top, search],
    queryFn: async () => {
      const { data } = await api.searchUsersByName(search, top);
      return data;
    },
    ...options,
  });
}
